var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChartGenerator',{attrs:{"chart-data":_vm.chartData,"chart-id":_vm.chartId,"chart-options":_vm.chartOptions,"css-classes":_vm.cssClasses,"dataset-id-key":_vm.datasetIdKey,"height":_vm.height,"plugins":_vm.plugins,"styles":_vm.styles,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }